export const CreditCard = () => (
  <svg width='70' height='40' viewBox='0 0 70 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M66.2655 40H3.73436C1.67216 40 0 38.3413 0 36.2956V3.70437C0 1.65873 1.67216 0 3.73436 0H66.2655C68.3278 0 69.9999 1.65873 69.9999 3.70437V36.2949C69.9999 38.3413 68.3278 40 66.2655 40Z'
      fill='#BDBDBD'
    />
    <path
      d='M66.2658 0H65.2517V16.8602C65.2517 28.3395 55.871 37.6448 44.2988 37.6448H0.264648C0.809273 39.022 2.1535 40 3.73464 40H66.2658C68.328 40 70.0002 38.3413 70.0002 36.2956V3.70437C70.0002 1.65873 68.328 0 66.2658 0Z'
      fill='#A2A2A2'
    />
    <path
      d='M16.6951 13.0295H8.72C7.87272 13.0295 7.18652 12.3481 7.18652 11.5084V7.24869C7.18652 6.40823 7.87344 5.72754 8.72 5.72754H16.6951C17.5423 5.72754 18.2285 6.40894 18.2285 7.24869V11.5084C18.2285 12.3481 17.5423 13.0295 16.6951 13.0295Z'
      fill='#EAA500'
    />
    <path
      d='M17.3547 20.7999H8.06073C7.61506 20.7999 7.25391 20.4424 7.25391 19.9996C7.25391 19.5568 7.61506 19.1992 8.06073 19.1992H17.3555C17.8011 19.1992 18.1623 19.5568 18.1623 19.9996C18.1623 20.4424 17.8004 20.7999 17.3547 20.7999Z'
      fill='#545C56'
    />
    <path
      d='M30.9338 20.7999H21.6398C21.1942 20.7999 20.833 20.4424 20.833 19.9996C20.833 19.5568 21.1942 19.1992 21.6398 19.1992H30.9346C31.3802 19.1992 31.7414 19.5568 31.7414 19.9996C31.7414 20.4424 31.3795 20.7999 30.9338 20.7999Z'
      fill='#545C56'
    />
    <path
      d='M44.5134 20.7999H35.218C34.7723 20.7999 34.4111 20.4424 34.4111 19.9996C34.4111 19.5568 34.7716 19.1992 35.218 19.1992H44.5134C44.9591 19.1992 45.3202 19.5568 45.3202 19.9996C45.3202 20.4424 44.9591 20.7999 44.5134 20.7999Z'
      fill='#545C56'
    />
    <path
      d='M58.0925 20.7999H48.7971C48.3514 20.7999 47.9902 20.4424 47.9902 19.9996C47.9902 19.5568 48.3507 19.1992 48.7971 19.1992H58.0925C58.5382 19.1992 58.8993 19.5568 58.8993 19.9996C58.8993 20.4424 58.5382 20.7999 58.0925 20.7999Z'
      fill='#545C56'
    />
    <path
      d='M25.4208 34.4015H8.06073C7.61506 34.4015 7.25391 34.0439 7.25391 33.6011C7.25391 33.159 7.61506 32.8008 8.06073 32.8008H25.4208C25.8665 32.8008 26.2276 33.1583 26.2276 33.6011C26.2276 34.0439 25.8665 34.4015 25.4208 34.4015Z'
      fill='#545C56'
    />
    <path
      d='M25.4209 29.6007H19.3527C18.9071 29.6007 18.5459 29.2431 18.5459 28.8003C18.5459 28.3575 18.9071 28 19.3527 28H25.4209C25.8665 28 26.2277 28.3575 26.2277 28.8003C26.2277 29.2431 25.8665 29.6007 25.4209 29.6007Z'
      fill='#545C56'
    />
    <path
      d='M56.1957 27.4922C55.0544 27.4922 54.0475 28.0181 53.3729 28.8263C52.6975 28.0181 51.6906 27.4922 50.5501 27.4922C48.5175 27.4922 46.8691 29.1273 46.8691 31.1435C46.8691 33.1598 48.5175 34.7949 50.5501 34.7949C51.6913 34.7949 52.6982 34.269 53.3729 33.4607C54.0482 34.269 55.0551 34.7949 56.1957 34.7949C58.2282 34.7949 59.8766 33.1598 59.8766 31.1435C59.8766 29.1266 58.2282 27.4922 56.1957 27.4922Z'
      fill='#545C56'
    />
  </svg>
);
